import MyDocuments from './MyDocuments';
export { MyDocuments };
export default MyDocuments;
